import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-account-single-ticket',
  templateUrl: './account-single-ticket.component.html',
  styleUrls: ['./account-single-ticket.component.css']
})
export class AccountSingleTicketComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

}
